import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { tos } from './tos';

export const tenant = {
  id: 'eurbridge',
  name: 'EurBridge Logistics USA',
  isSystemTenant: false,
  domains: [
    'eurbridge.localhost',
    'eurbridge.demo.pelicargo.dev',
    'eurbridge.tenant.pelicargo.dev',
    'eurbridge.com',
    /eurbridge\.staging-\d+\.pelicargo\.dev/,
  ],
  customerTheme: {
    colors: {
      primary: {
        '50': '#F3F7FE',
        '100': '#E5EDFE',
        '200': '#CADBFE',
        '300': '#A9C3FF',
        '400': '#83A8FE',
        '500': '#2445A8',
        '600': '#163294',
        '700': '#0A207C',
        '800': '#041061',
        '900': '#020249',
      },
      secondary: {
        '50': '#F7F7F7',
        '100': '#EDEDED',
        '200': '#DBDBDB',
        '300': '#C4C4C4',
        '400': '#ABABAB',
        '500': '#555555',
        '600': '#444444',
        '700': '#333333',
        '800': '#232323',
        '900': '#151515',
      },
    },
    logoDims: {
      height: 16,
      width: undefined,
    },
    fullLogoDims: {
      height: '80px',
      width: '320px',
    },
  },
  emailTheme: {
    ...baseEmailTheme,
    primary: '#2445A8',
  },
  emailAssets: {
    ...baseEmailAssets,
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/eurbridge/logo.png',
    'logo-dark':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/eurbridge/eurbridge_dark.svg',
    'logo-dark-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/eurbridge/eurbridge_dark.svg',
    'logo-light':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/eurbridge/eurbridge_light.svg',
    'logo-light-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/eurbridge/eurbridge_light.svg',
    twitterUrl: 'https://to-be-determined/',
    facebookUrl: 'https://to-be-determined/',
    linkedinUrl: 'https://www.linkedin.com/company/eurbridge-logistics-usa/about/',
    siteUrl: 'https://eurbridgelogisticsusa.com',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: false,
      airports: false,
      contacts: true,
      instructions: false,
      users: true,
      backlogs: false,
      'ai-inbox': false,
      surcharges: false,
      rates: false,
      'route-editor': false,
      configuration: false,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: false,
        AirlineBooking: false,
        RequestSchedule: false,
        BookingChange: false,
        BookingCancel: false,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: false,
    },
  },
  accountTypes: {
    IAC: false,
    IATA: false,
    ORGANIZATION: false,
    UNCERTIFIED: true,
  },
  customer: {
    requestFormDefaults: {
      freight_service: 'EXW',
      is_consolidated: true,
      extra_freight_services: [],
    },
    freightServices: {
      UNCERTIFIED: ['EXW', 'FCA'],
      default: ['EXW', 'FCA'],
    },
  },
  termsOfService: tos,
  helpUrl: 'https://docs.google.com/document/d/1CPAqKNH8qkimkl9ONXIB-8Lh-n9VbJTe9diBDWWqsW4/edit?usp=drive_link',
} as const satisfies TenantInfo<'eurbridge'>;
